export default {"src":"/_next/static/media/bottom-curved-polygon.564aa22a.svg","height":473,"width":720,"blurWidth":0,"blurHeight":0};